import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { Box } from '@material-ui/core'

import theme from 'theme'

const ConfigurationSkeleton = () => {
  return (
    <Box
      pt={2}
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(2)}
    >
      <Skeleton variant="rect" width="100%" height={60} />
      <Skeleton variant="rect" width={200} height={30} />
      <Skeleton variant="rect" width="100%" height={177} />
      <Skeleton variant="rect" width="100%" height={54} />
      {[0, 1].map((_, index) => (
        <Skeleton key={index} variant="rect" width="100%" height={162} />
      ))}
      <Box display="flex" justifyContent="end" gridGap={theme.spacing(2)}>
        <Skeleton variant="rect" width={70} height={30} />
        <Skeleton variant="rect" width={70} height={30} />
      </Box>
    </Box>
  )
}

export default ConfigurationSkeleton
